import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B89607FB-8199-48B0-AF59-E048CAEB210B
 * name cellphone-play
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-play.svg
 * tags
 * - Cellphone / Phone 
 */
export const CellphonePlayIcon = createSvgIcon(<><path d="M17 19H7V5H17M17 1H7C5.89 1 5 1.89 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.89 18.1 1 17 1M10 9V15L14 12L10 9Z" /></>, 'CellphonePlayIcon');
export default CellphonePlayIcon